module.exports = __webpack_public_path__ + "static/media/TeacherContent3.eff4daf8.svg";